<template>
  <div>
    <spinner v-if="loading" />
    <div v-else>
      <div v-for="(ticket, index) in ticketsInfo" :key="index">
        <div
          v-if="[194, 294].includes(Number(organization.id))"
          :class="Number(organization.id) === 294 ? 'zf-ticket-container' : 'ticket-container'"
          :style="index !== ticketsInfo.length - 1 && 'page-break-after: always'"
        >
          <fraktura-ticket-seller-pdf
            v-if="Number(organization.id) === 194"
            :event-info="eventInfo"
            :organization="organization"
            :index="index"
            :ticket-info="ticket"
          />
          <zf-ticket-seller-pdf
            v-else-if="Number(organization.id) === 294"
            :event-info="eventInfo"
            :ticket-count="ticketsInfo.length"
            :organization="organization"
            :index="index"
            :ticket-info="ticket"
          />
        </div>
        <pdf-ticket
          v-else
          :print-design="true"
          :event-info="eventInfo"
          :buyer="buyer"
          :seller-name="sellerName"
          :is-custom-fiscalisation="isCustomFiscalisation"
          :ticket-seller-organization="ticketSellerOrganization"
          :hide-price="hidePrice"
          :purchased-at="ticket.createdAt"
          :organization="organization"
          :ticket-name="ticket.orderItem.name"
          :ticket-price="ticket.orderItem.price"
          :ticket-location="ticket.accreditation.ticketLocation"
          :qrcode="ticket.accreditation.qrcode"
          :barcode="ticket.accreditation.barcode"
          :fiscalisation-info="fiscalisationInfo"
          :order-number="`${ticket.orderId}-${index + 1}`"
          :ticket-index="index"
          :tickets-info="ticketsInfo"
        />
      </div>
      <ticket-seller-ticket-invoice-pdf
        v-if="Number(organization.id) !== 294"
        :fiscalisation-info="fiscalisationInfo"
        :ticket-seller-organization="ticketSellerOrganization"
        :organization="organization"
        :event-info="eventInfo"
        :tickets-info="ticketsInfo"
        :order="order"
      />
      <div v-if="![194, 188, 294].includes(Number(organization.id))">
        <div v-for="(notATicket, i) in notATickets" :key="'not' + i">
          <not-a-ticket :is-last="i + 1 === notATickets.length" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import pdfTicket from './pdf-ticket.vue'
import notATicket from './not-a-ticket.vue'
import FrakturaTicketSellerPdf from '@/components/builder/FrakturaTicketSellerPdf.vue'
import { getOrderInfoByUUID } from '../../http'
import i18next from 'i18next'
import TicketSellerTicketInvoicePdf from '@/components/ticket-seller/tickets/ticket-seller-ticket-invoice-pdf.vue'
import ZfTicketSellerPdf from '@/components/builder/ZFTicketSellerPdf.vue'

export default {
  name: 'ticket-seller-pdf',
  components: {
    ZfTicketSellerPdf,
    TicketSellerTicketInvoicePdf,
    pdfTicket,
    notATicket,
    FrakturaTicketSellerPdf,
  },
  props: {
    uuid: String,
  },
  data() {
    return {
      purchases: [],
      loading: true,
      eventInfo: {},
      notATickets: 0,
      sellerName: '',
      buyer: {},
      ticketsInfo: [],
      orderCreatedAt: '',
      organization: null,
      isCustomFiscalisation: false,
      ticketSellerOrganization: {},
      hidePrice: false,
      fiscalisationInfo: {},
      order: {},
    }
  },
  async mounted() {
    const params = new URL(document.location).searchParams
    this.hidePrice = params.get('hidePrice') === 'true'
    const {
      buyer,
      user: { firstName, type, ...userData },
      event: {
        location: { address1, city, country, venue },
        from,
        to,
        title,
        organization,
        fixedFeePerTicket,
      },
      ...eventDetails
    } = await getOrderInfoByUUID(this.uuid)
    this.hidePrice = eventDetails.paymentType === 'FREE'
    this.buyer = buyer
    this.ticketsInfo = eventDetails.purchases
    this.order = eventDetails

    // + 1 is for invoice
    const totalParts = eventDetails.purchases.length + 1
    if (totalParts % 4 > 0) {
      this.notATickets = Array(4 - (totalParts % 4)).fill('notATicket')
    }

    this.sellerName = type === 'TICKET_SELLER' ? userData.ticketSellerOrganization.name : ''
    this.isCustomFiscalisation =
      (userData.ticketSellerOrganization &&
        userData.ticketSellerOrganization.isCustomFiscalisation) ||
      false
    this.ticketSellerOrganization = (userData && userData.ticketSellerOrganization) || {}
    this.fiscalisationInfo = { ...eventDetails.fiscalisationInfo, totalPrice: 0 }

    eventDetails.purchases.forEach(p => {
      this.fiscalisationInfo.totalPrice += Number(Math.round(p.orderItem.price * 100).toFixed(2))
    })

    i18next.changeLanguage(organization.preferredLanguage === 'en' ? 'en' : 'hr')
    this.organization = { ...organization }

    const isSameDay = moment(from).isSame(moment(to), 'day')

    const eventAddress = [address1, city, country].filter(e => e != null && e !== '').join(', ')

    this.eventInfo = {
      eventTitle: title,
      eventAddress: eventAddress,
      fixedFeePerTicket,
      eventDate: `${this.formatDate(from, true)}${
        !isSameDay ? ` - ${this.formatDate(to, false)}` : ''
      }`,
      eventFrom: from,
      venue,
    }
    this.loading = false

    setTimeout(window.print, 1000)
  },
  methods: {
    formatDate(date, withHours = true) {
      return (
        moment(date)
          .tz('Europe/Zagreb')
          .format(`DD. MMMM YYYY.${withHours ? ' u HH:mm' : ''}`) + `${withHours ? ' sati' : ''}`
      )
    },
  },
}
</script>

<style scoped>
.page-break {
  page-break-after: always;
}

.ticket-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 6.08cm !important;
  height: 16.62cm !important;
  transform: rotateY(180deg);
  transform: rotateX(20deg);
}
.zf-ticket-container {
  height: 175mm !important;
  width: 80mm !important;
}
</style>
